import * as React from 'react'

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    ListItem,
    useMediaQuery
} from '@mui/material'
import { Logout } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import Carousel from 'react-material-ui-carousel'

import A from '../../../../assets/images/Logos/Parceiros/logo_a.png';
import Az3 from '../../../../assets/images/Logos/Parceiros/logo_az3.png';
import Brasil from '../../../../assets/images/Logos/Parceiros/logo_br84.png';
import Fala from '../../../../assets/images/Logos/Parceiros/logo_fala.png';
import Filadelfia from '../../../../assets/images/Logos/Parceiros/logo_filadelfia.png';
import G30 from '../../../../assets/images/Logos/Parceiros/logo_g30.png';
import Hs from '../../../../assets/images/Logos/Parceiros/logo_hs.png';
import Klash from '../../../../assets/images/Logos/Parceiros/logo_k.png';
import Loggi from '../../../../assets/images/Logos/Parceiros/logo_loggi.png';


import { Navigation, Pagination, Scrollbar, A11y, Autoplay  } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

import { ItemText } from '../../../itemText';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { BaseDiv } from './styles'

interface INavBar {

}



const CarrouselParceiros: React.FC<INavBar> = () => {
    const navigate = useNavigate();
    const matches = useMediaQuery('(max-width:1000px)');


    const dados = [
        {image:A},
        {image:Az3},
        {image:Brasil},
        {image:Fala},
        {image:Filadelfia},
        {image:G30},
        {image:Hs},
        {image:Klash},
        {image:Loggi},
    ]

    return (
        <BaseDiv id='parc'>
            <Box
                sx={{
                    width: '90%',
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center"   
                }}
            >
                <ListItem
                    sx={{
                        padding: 1,
                        flexDirection: 'row', 
                        textAlign: "center"                      
                    }}
                >
                    <ItemText 
                        primary="AGÊNCIAS PARCEIRAS"
                        hideSecondary 
                        primarySx={{
                            marginBottom: 3,
                            color:  "var(--purple-dark)",
                            fontWeight: '600',
                            fontSize: '36px',
                            fontFamily: "Poppins"
                        }}
                        secondarySx={{
                            fontSize: '24px'
                        }}
                    />
                </ListItem>
                <Swiper
                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={1}
                    slidesPerView={matches ? 2 : 4}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 1500,
                        disableOnInteraction: true,
                    }}
                    style={{
                        display: 'flex',
                        textAlign: 'center',
                        maxWidth: '100%',
                        height: '230px',
                    }}
                >
                    {dados.map((data:any, index: number) => (
                        <SwiperSlide
                            key={index}
                            style={{
                                width: matches ? '50%' : '70%'
                            }}
                        >
                            <img src={data?.image} width={matches ? 120 : 180 }/>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Box>
        </BaseDiv>
    );
}

export { CarrouselParceiros }